import {
  ReasonCategory,
  NotScamReason,
  ScamReason,
  WrongCategoryReason
} from './types'

export default [
  [
    ReasonCategory.NotScamLikely,
    Object.values(NotScamReason)
  ],
  [
    ReasonCategory.ScamLikely,
    Object.values(ScamReason)
  ],
  [
    ReasonCategory.WrongCategory,
    Object.values(WrongCategoryReason)
  ]
]
